export const getTitle = (title, children) => {
    if (title) return title;

    if (typeof children === "string") return children;

    if (
        Array.isArray(children) &&
        !children.some((value) => typeof value !== "string")
    )
        return children.join("");

    return;
};
